import type { PatientAllergy } from '@/api/medications';

export type AllergyStatus = 'has_allergies' | 'none_known' | 'unknown';

// From the kept rows: allergies, "sin alergias conocidas", or nobody asked.
export function allergyStatus(rows: PatientAllergy[]): AllergyStatus {
  if (rows.some((row) => row.kind === 'allergy')) return 'has_allergies';

  return rows.some((row) => row.kind === 'none_known') ? 'none_known' : 'unknown';
}

// The allergies to any of a drug's active ingredients. Allergies in words
// (a drug class, a food) name no substance and never match.
export function allergiesTo(rows: PatientAllergy[], substanceIds: number[]): PatientAllergy[] {
  return rows.filter((row) => row.kind === 'allergy' && row.substanceId !== null &&
    substanceIds.includes(row.substanceId));
}

// "penicilina (Grave)": the severity only when it was given.
export function allergyLabel(allergy: PatientAllergy): string {
  return allergy.severity === 'unknown' ? `${allergy.name}` : `${allergy.name} (${allergy.humanSeverity})`;
}
